import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceCliente from "../../../../services/serviceCliente";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        id: string;
        tipoFaturaCliente: string;
        nomeCliente: string;
        codigoExternoCliente: string;
        numeroDocumentoClienteFormatado: string;
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        tipoFaturaCliente: yup.string().required(messages.requiredField).typeError(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            tipoFaturaCliente: "",
            nomeCliente: "",
            codigoExternoCliente: "",
            numeroDocumentoClienteFormatado: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const tipoFaturaClienteOptions = [
        { label: "Cliente", value: "Cliente" },
        { label: "Instalação", value: "Instalação" },
    ];

    const onSubmit = (values: any) => {
        setDisable(true);

        const updateValues = {
            ...values,
            clienteID: data.id,
        };

        serviceCliente
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };
    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar Cliente
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <TextInput name="id" label="ID do cliente" control={control} disabled={true} />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput name="nomeCliente" label="Nome" control={control} disabled={true} />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="numeroDocumentoClienteFormatado"
                                label="Documento"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="codigoExternoCliente"
                                label="Código Externo"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                name="tipoFaturaCliente"
                                label="Faturar por"
                                options={tipoFaturaClienteOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
